import React, { useState }from 'react';
import { useSelector, useDispatch } from "react-redux";
import { resetPagination } from 'reducers/paginationStoresSlice';
import { resetFilters } from 'reducers/filtersStoresSlice';
import { useTranslation } from "react-i18next" 
import { Link } from 'react-router-dom';
import { Navigate } from 'react-router-dom'; 
import DashboardIcon from '@mui/icons-material/Dashboard';
import FeedIcon from '@mui/icons-material/Feed';
import SettingsIcon from '@mui/icons-material/Settings'; 
import { ToastContainer } from 'react-toastify'; 
import { TodayIs} from 'components/utils/TodayIs';
import ImportScript from 'components/utils/ImportScript';
import Footer from "pages/main/Footer";
import Alerts from 'pages/alerts/Alerts';
import Messages from 'pages/messages/Messages';
import LogoutIcon from '@mui/icons-material/Logout';
import StoresFilter from "pages/stores/storesFilterList/StoresFilter";

const HomeStore = () => {
    const {t,i18n} = useTranslation(['listDataStores']);
    const dispatch = useDispatch();
    const filtersStoreDetails = useSelector((state) => state.filtersStores); // Obtener filtros desde Redux
    const enabled = useSelector((state) => state.loginUser.enabled);
    const roles = useSelector((state) => state.loginUser.roles);  
    const defaultStore = useSelector((state) => state.loginUser.defaultStore);  
    const [showModalStoreSettings, setShowModalStoreSettings] = useState(true); 
   
    const scriptUrl = '/js/sb-admin-2.min.js'; 

    function changeSelectedLanguage(){
        i18n.language==="es"?i18n.changeLanguage("en"):i18n.changeLanguage("es");
    };
   
    const closeModalStores = () => {    
        dispatch(resetPagination());
        dispatch(resetFilters());
        setShowModalStoreSettings(false);
        return () => {};
      };

    return (
    <>
        <ImportScript resourceUrl={scriptUrl} />
        <ToastContainer></ToastContainer>
        {enabled===false ? <Navigate to="/"/>:
        <div id="page-top">
           
            {/* Page Wrapper */}
            <div id="wrapper">

                {/* Sidebar */}
                <ul className="navbar-nav bg-gradient-primary sidebar sidebar-dark accordion" id="accordionSidebar">

                    {/* Sidebar - Brand */}
                    <Link className="sidebar-brand d-flex align-items-center justify-content-center" to="/home">
                        <div className="sidebar-brand-icon rotate-n-15">
                            <DashboardIcon/>
                        </div>
                        <div className="sidebar-brand-text mx-3">{t('Text_Title')}</div>
                    </Link>

                    {/* Divider */}
                    <hr className="sidebar-divider my-0"/>

                    {/* Nav Item - Dashboard */}
                    <li className="nav-item active">
                        <div className="nav-link">
                            <i className="fas fa-fw fa-tachometer-alt"></i>
                            <span>{t('Menu_Main')}</span></div>
                    </li>

                    {/* Divider */}
                    <hr className="sidebar-divider"/>

                    {/* Sidebar - INFORMATION FILTROS APLICADOS */}
                    <li className="nav-item active">
                        <Link className="nav-link" to="/Store">
                            <FeedIcon/>
                            <span> {t('Text_Information')}</span>
                        </Link>
                    </li>
                    <div className={filtersStoreDetails.idFrom===''?"sidebar-heading":"sidebar-heading text-white"}>   
                        {t('Text_Filter_Code_From')}
                    </div>
                    <li className={filtersStoreDetails.idFrom===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersStoreDetails.idFrom==='' ? t('Text_Filter_Not_Apply'): filtersStoreDetails.idFrom}
                    </li>
                    <div className={filtersStoreDetails.idTo===''?"sidebar-heading":"sidebar-heading text-white"}>   
                        {t('Text_Filter_Code_To')}
                    </div>
                    <li className={filtersStoreDetails.idTo===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersStoreDetails.idTo==='' ? t('Text_Filter_Not_Apply'): filtersStoreDetails.idTo}
                    </li>

                    <div className={filtersStoreDetails.documentIdFrom===''?"sidebar-heading":"sidebar-heading text-white"}> 
                        {t('Text_Filter_documentId_From')}
                    </div>
                    <li className={filtersStoreDetails.documentIdFrom===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersStoreDetails.documentIdFrom==='' ? t('Text_Filter_Not_Apply'): filtersStoreDetails.documentIdFrom}
                    </li>
                    <div className={filtersStoreDetails.documentIdTo===''?"sidebar-heading":"sidebar-heading text-white"}>
                        {t('Text_Filter_documentId_To')}
                    </div>
                    <li className={filtersStoreDetails.documentIdTo===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersStoreDetails.documentIdTo==='' ? t('Text_Filter_Not_Apply'): filtersStoreDetails.documentIdTo}
                    </li>
                    <div className={filtersStoreDetails.tradenameFrom===''?"sidebar-heading":"sidebar-heading text-white"}> 
                        {t('Text_Filter_tradename_From')}
                    </div>
                    <li className={filtersStoreDetails.tradenameFrom===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersStoreDetails.tradenameFrom==='' ? t('Text_Filter_Not_Apply'): filtersStoreDetails.tradenameFrom}
                    </li>

                    <div className={filtersStoreDetails.tradenameTo===''?"sidebar-heading":"sidebar-heading text-white"}> 
                        {t('Text_Filter_tradename_To')}
                    </div>
                    <li className={filtersStoreDetails.tradenameTo===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersStoreDetails.tradenameTo==='' ? t('Text_Filter_Not_Apply'): filtersStoreDetails.tradenameTo}
                    </li>

                    <div className={filtersStoreDetails.nameFrom===''?"sidebar-heading":"sidebar-heading text-white"}>   
                        {t('Text_Filter_name_From')}
                    </div>
                    <li className={filtersStoreDetails.nameFrom===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersStoreDetails.nameFrom==='' ? t('Text_Filter_Not_Apply'): filtersStoreDetails.nameFrom}
                    </li>
                    <div className={filtersStoreDetails.nameTo===''?"sidebar-heading":"sidebar-heading text-white"}>   
                        {t('Text_Filter_name_To')}
                    </div>
                    <li className={filtersStoreDetails.nameTo===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersStoreDetails.nameTo==='' ? t('Text_Filter_Not_Apply'): filtersStoreDetails.nameTo}
                    </li>

                    <div className={filtersStoreDetails.contacpersonFrom===''?"sidebar-heading":"sidebar-heading text-white"}>   
                        {t('Text_Filter_contactName_From')}
                    </div>
                    <li className={filtersStoreDetails.contacpersonFrom===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersStoreDetails.contacpersonFrom==='' ? t('Text_Filter_Not_Apply'): filtersStoreDetails.contacpersonFrom}
                    </li>
                    <div className={filtersStoreDetails.contacpersonTo===''?"sidebar-heading":"sidebar-heading text-white"}>   
                        {t('Text_Filter_contactName_To')}
                    </div>
                    <li className={filtersStoreDetails.contacpersonTo===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersStoreDetails.contacpersonTo==='' ? t('Text_Filter_Not_Apply'): filtersStoreDetails.contacpersonTo}
                    </li> 

                    <div className={filtersStoreDetails.emailsFrom===''?"sidebar-heading":"sidebar-heading text-white"}>
                        {t('Text_Filter_emails_From')}
                    </div>
                    <li className={filtersStoreDetails.emailsFrom===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersStoreDetails.emailsFrom==='' ? t('Text_Filter_Not_Apply'): filtersStoreDetails.emailsFrom}
                    </li>
                    <div className={filtersStoreDetails.emailsTo===''?"sidebar-heading":"sidebar-heading text-white"}>
                        {t('Text_Filter_emails_To')}
                    </div>
                    <li className={filtersStoreDetails.emailsTo===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersStoreDetails.emailsTo==='' ? t('Text_Filter_Not_Apply'): filtersStoreDetails.emailsTo}
                    </li>
                    <div className={filtersStoreDetails.phonesFrom===''?"sidebar-heading":"sidebar-heading text-white"}>
                        {t('Text_Filter_phones_From')}
                    </div>
                    <li className={filtersStoreDetails.phonesFrom===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersStoreDetails.phonesFrom==='' ? t('Text_Filter_Not_Apply'): filtersStoreDetails.phonesFrom}
                    </li>
                    <div className={filtersStoreDetails.phonesTo===''?"sidebar-heading":"sidebar-heading text-white"}>
                        {t('Text_Filter_phones_To')}
                    </div>
                    <li className={filtersStoreDetails.phonesTo===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersStoreDetails.phonesTo==='' ? t('Text_Filter_Not_Apply'): filtersStoreDetails.phonesTo}
                    </li>
                    
                    <li className="sidebar-heading text-warning">
                    &nbsp;
                    </li>
                    <div className={!filtersStoreDetails.enabled?"sidebar-heading":"sidebar-heading text-white"}>
                        <i className="fas fa-solid fa-circle" style={{color:(filtersStoreDetails.enabled)?"#32CD32":"#FFFFFF"}}></i> {t('Text_Filter_Habilty')}
                    </div>
                    <div className={!filtersStoreDetails.notenabled?"sidebar-heading":"sidebar-heading text-white"}>
                        <i className="fas fa-solid fa-circle" style={{color:(filtersStoreDetails.notenabled)?"#32CD32":"#FFFFFF"}}></i> {t('Text_Filter_Not_Habilty')}
                    </div>
                    <li className="sidebar-heading text-warning">
                    &nbsp;
                    </li>
                    {/* Divider */}
                    <hr className="sidebar-divider"/>

                    {/* Heading */}
                    {/* Nav Item - Admin Collapse Menu */}
                    {roles[0].listmenus.find((key)=>(key.name==="Menu_Settings"))&&
                        <li className="nav-item">
                            <Link className="nav-link collapsed" to="/Store" data-toggle="collapse" data-target="#collapseAdmin"
                                aria-expanded="true" aria-controls="collapseAdmin">
                                <SettingsIcon/>
                                <span>{t('Menu_Settings')}</span>
                            </Link>
                            <div id="collapseAdmin" className="collapse" aria-labelledby="headingAdmin"
                                data-parent="#accordionSidebar">
                                <div className="bg-white py-2 collapse-inner rounded">
                                    <h6 className="collapse-header">{t('Custom_Menu_Settings')}</h6>
                                    <Link className="collapse-item" to="/Store" onClick={changeSelectedLanguage}>{i18n.language==="es"?t('SubMenu_Settings_ChangeToEnglish'):t('SubMenu_Settings_ChangeToSpanish')}</Link>
                                </div>
                            </div>
                        </li>
                    }
                    {/* Nav Item - Charts */}                  
                    <li className="nav-item">
                        <Link className="nav-link" to="/home" onClick={closeModalStores}>
                            <LogoutIcon/>
                            <span>{t('Button_Back')}</span>
                        </Link>
                    </li>

                    {/* Divider */}
                    <hr className="sidebar-divider d-none d-md-block"/>

                    {/* Sidebar Toggler (Sidebar) */}
                    <div className="text-center d-none d-md-inline">
                        <button className="rounded-circle border-0" id="sidebarToggle"></button>
                    </div>

          
                </ul>
                {/* End of Sidebar */}

                {/* Content Wrapper */}
                <div id="content-wrapper" className="d-flex flex-column">

                {/* Main Content */}
                <div id="content">

                    {/* Topbar  */}
                    <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">

                        {/* Sidebar Toggle (Topbar)  */}
                        <button id="sidebarToggleTop" className="btn btn-link d-md-none rounded-circle mr-3">
                            <i className="fa fa-bars"></i>
                        </button>
                        
                        {/* Topbar Navbar */}
                        <ul className="navbar-nav ml-auto">
                            <div className="topbar-divider d-none d-sm-block"></div>
                                <div className="text-center">
                                    <br/>
                                    {t('Text_StoreSelected')}&nbsp;{ defaultStore.tradename===null ? t('Text_StoreEmpty'):defaultStore.tradename }
                                </div>      
                                
                            <div className="topbar-divider d-none d-sm-block"></div>
                            {/* Nav Item - Alerts */}
                            <Alerts/>
                            {/* Nav Item - Messages */}
                            <Messages/>
                            <div className="topbar-divider d-none d-sm-block"></div>
                            {/* Nav Item - User Information */}
                            <li className="nav-item dropdown no-arrow mx-1">
                                <br/>
                                <span className="mr-2 d-none d-lg-inline text-gray-600 small">
                                    <TodayIs/>  
                                </span>
                            </li>
                        </ul>
                    </nav>
                    {/* End of Topbar */}
                
                {/* Show Modals */}  
                <StoresFilter 
                    showModalStoreSettings={showModalStoreSettings} 
                    setShowModalStoreSettings={setShowModalStoreSettings}
                />
                  
                </div>
                {/* End of Main Content */}

                {/* Footer */}
                <Footer/>
                {/* End of Footer */}

            </div>
            {/* End of Content Wrapper */}

          </div>
          {/* End of Page Wrapper */}
         
      </div>}
      {/* End of Body */}

    </>
  )
};

export default HomeStore;
